<template>
  <div class="panel__content__element">
    <div class="g-handle" />
    <accordion-element-component
      class="g-grey-box"
      v-bind="{Data: {icon: ['custom', 'electrical'], title: $t('messages.electrical.title'), subTitle: computedPowerStatusTitle}}"
    >
      <ul>
        <li>
          <div class="electrical-grid">
            <voltage-gauge-component :voltage = "voltage" />
            <current-gauge-component :current = "current" />
          </div>
        </li>
      </ul>
    </accordion-element-component>
  </div>
</template>

<script>
import AccordionElement from '@/components/elements/AccordionElement'
import CurrentGauge from '@/components/CurrentGauge.vue'
import VoltageGauge from '@/components/VoltageGauge.vue'

export default
{
  name: 'AccordionElectrical',
  components:
  {
    'voltage-gauge-component': VoltageGauge,
    'current-gauge-component': CurrentGauge,
    'accordion-element-component': AccordionElement
  }, // Available in this.$options.name
  props: {
    voltage: {
      type: Number,
      default: null
    },
    current: {
      type: Number,
      default: null
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedPowerStatusTitle() {
      const voltage = this.voltage / 100
      const current = this.current
      return `${voltage}V ${this.$t('messages.electrical.and')} ${current}mA`
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.electrical-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(249px, 1fr));
  align-items: center;
  justify-content: space-around;
}
</style>
